import { useAppStore } from '../store';
/* eslint-disable import/no-cycle */
type StepConfigItem = {
  name: string;
  age?: string;
  role?: string;
  [key: string]: unknown;
};

type BuildConfigArgs = {
  config: StepConfigItem[];
  age?: string;
  role?: string;
  configName?: string;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type RootState = any;

function buildConfig({ config, age, role }: BuildConfigArgs): StepConfigItem[] {
  const buildedConfig: StepConfigItem[] = [];

  config.forEach((el) => {
    if (el.age) {
      if (el.age === age) {
        buildedConfig.push(el);
      }
    } else if (el.role) {
      if (el.role === role) {
        buildedConfig.push(el);
      }
    } else {
      buildedConfig.push(el);
    }
  });

  if (!useAppStore.getState().withoutMail) {
    buildedConfig.push({
      name: 'mail',
    });
  }

  return buildedConfig;
}

export default buildConfig;
